module.exports = __webpack_public_path__ + "img/vol02_cup01_label04.1b597845.png";